import React from "../web_modules/react.js";
import Select from "../web_modules/react-select.js";
import countryDialingCodes from "./data/country_dialing_codes.json";
const countryDialingCodeOptions = countryDialingCodes.map(code => ({
  label: code,
  value: code
}));
export default function CountryDialingCodeSelect({
  defaultCode = "+45"
}) {
  const defaultValue = countryDialingCodeOptions.find(({
    value
  }) => value === defaultCode);
  return /*#__PURE__*/React.createElement(Select, {
    name: "country_prefix",
    required: true,
    styles: {
      control: styles => ({ ...styles,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }),
      valueContainer: styles => ({ ...styles,
        minWidth: 50,
        minHeight: 38
      })
    },
    options: countryDialingCodeOptions,
    defaultValue: defaultValue
  });
}